<template>

    <div class="container">

        <div class="my-4">
            <inertia-link :href="route('messages.index')">
                <i class="bi bi-arrow-left"></i>
                {{ __('zurück') }}
            </inertia-link>
        </div>

        <div class="my-4">
            <h1>{{ message.subject }}</h1>
        </div>
        <div class="my-4">
            {{ __('von: :name', {name: message.sender.name}) }}
        </div>

        <div class="mb-4" v-html="message.formatted_text">
        </div>

        <div>
            <button type="button" class="btn btn-outline-danger" @click="destroy" v-if="message.deleted_at === null">
                {{ __('Löschen') }}
            </button>
        </div>

        <hr />
        <div>
            <h3>{{ __('Direkt antworten') }}</h3>

            <message-form :recipient="message.sender_id" :emoticons="emoticons" :subject="replySubject" />

        </div>

    </div>

</template>

<script>

    import MessageForm from './MessageForm';

    export default {
        props: [
            'message',
            'emoticons',
            'replySubject',
        ],
        data() {
            return {

            }
        },
        components: {
            MessageForm,
        },
        methods: {
            destroy() {
                this.$inertia.delete(this.route('messages.delete', this.message));
            },
        },
    }
</script>